module.exports = __webpack_public_path__ + "img/avatar3.35a7316a.png";